import MediaLibrary from '../../components/MediaLibrary/MediaLibrary'
import ParticleCanvas from './ParticleCanvas'
import TiptapEditor from '../../components/TipTapEditor/TipTapEditor'

const TestView = () => {
  return (
    <div className="h-full w-full flex justify-center items-center">
      <TiptapEditor />
    </div>
  )
}

export default TestView
